import { BaseClient } from "../../../services";
import { ParametrosFilterRequest } from "../types/types";

export const fetchDashBoardSalesSintetico = async (params: ParametrosFilterRequest) =>{
    try {
        const response = await BaseClient.get("Admin/Relatorio/Get/Vendas/Dashboard", {params});
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
    }
};

export const fetchGrupoConcessionaria = async ()=> {
    try {
        const response = await BaseClient.get("Admin/Relatorio/Get/Grupo-Concessionaria",);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
    }
};

export const fetchDashBoardSales = async (params: ParametrosFilterRequest)=> {
    try {
        const response = await BaseClient.get("Admin/Relatorio/Get/Dashboard/Geral",{params});
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
    }
};

export const exportSalesSinteticoCsv = async (
    dat_inicial: string | null,
    dat_final: string | null,
    grupo_id?: string | null,
    concessionaria_id?: string | null,
   ) => {
    try {
      const response = await BaseClient.get("Admin/Relatorio/Get/Vendas/Detalhes/Csv", 
        {
        responseType: 'blob',
        params: {
        dat_inicial: dat_inicial,
        dat_final: dat_final,
        grupo_id: grupo_id || undefined,
        concessionaria_id: concessionaria_id || undefined,
      }});
  
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `vendas_detalhes_${dat_inicial}_${dat_final}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
  
      return { success: true };
    } catch (error: any) {
      return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar CSV. Contate o administrador." };
    }
   }


export const exportSalesSinteticoPdf = async (
    dat_inicial: string | null,
    dat_final: string | null,
    grupo_id?: string | null,
    concessionaria_id?: string | null,
   ) => {
    try {
      const response = await BaseClient.get("Admin/Relatorio/Get/Vendas/Detalhes/Pdf", 
        {
        responseType: 'blob',
        params: {
        dat_inicial: dat_inicial,
        dat_final: dat_final,
        grupo_id: grupo_id || undefined,
        concessionaria_id: concessionaria_id || undefined,
      }});
  
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `vendas_detalhes_${dat_inicial}_${dat_final}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
  
      return { success: true };
    } catch (error: any) {
      return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar PDF. Contate o administrador." };
    }
   }


export const fetchConcessionariaSintetico = async () => {
  try {
      const response = await BaseClient.get("Admin/Relatorio/Get/RelatorioConcessionariaSintetico");
      return response.data;
    } catch (error: any) {
      return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchConcessionariaAnalitico = async (params: ParametrosFilterRequest) => {
  try {
    const response = await BaseClient.get("Admin/Relatorio/Get/Concessionaria/Analitico", {params});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}

export const fetchShopkeeperSintetico = async(search: string | null) => {
  try {
    const response = await BaseClient.get(`Admin/Relatorio/Get/Revenda/Sintetico`, {params: {search: search || undefined}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchShopkeeperAnalitico = async(data_inicio: string, data_fim: string) => {
  try {
    const response = await BaseClient.get(`Admin/Relatorio/Get/Revenda/Analitico`, {params: {data_inicio, data_fim}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchPagamentoSintetico = async(concessionaria: string | null, revenda: string | null, data_inicio: string, data_fim:string) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Pagamento/Sintetico', {params: {concessionaria, revenda, data_inicio, data_fim}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const exportPagamentoSinteticoPdf = async (
  concessionaria: string | null,
  revenda: string | null,
  data_inicio: string,
  data_fim: string,
) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Pagamento/Sintetico/Pdf', {
      responseType: 'blob',
      params: {
        concessionaria: concessionaria || undefined,
        revenda: revenda || undefined,
        data_inicio,
        data_fim,
      },
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `pagamentos_sintetico_${data_inicio}_${data_fim}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar PDF. Contate o administrador." };
  }
};

export const exportPagamentoSinteticoExcel = async (
  concessionaria: string | null,
  revenda: string | null,
  data_inicio: string,
  data_fim: string,
) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Pagamento/Sintetico/Excel', {
      responseType: 'blob',
      params: {
        concessionaria: concessionaria || undefined,
        revenda: revenda || undefined,
        data_inicio,
        data_fim,
      },
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `pagamentos_sintetico_${data_inicio}_${data_fim}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar Excel. Contate o administrador." };
  }
};

export const fetchPagamentoAnalitico = async(id_concessionaria: string | null, data_inicio: string, data_fim:string) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Pagamento/Analitico', {params: {id_concessionaria,data_inicio, data_fim}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchInadimplenciaSintetico = async(search: string | null, data_inicio: string, data_fim:string) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Inadimplentes/Sintetico', {params: {search,data_inicio, data_fim}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fecthRevendasSemComprasSintetico = async (search: string | null, data_inicio: string, data_fim:string) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/RevendaSemCompra/Sintetico', {params: {search, data_inicio, data_fim}});
    return response.data;
  } catch (error:any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}

export const fetchUsuarioAnalitico = async () => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Usuario/Analitico',);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}


export const fetchAnunciosResumo = async (data_inicio: string, data_fim: string, id_grupo: string | null, id_concessionaria: string | null) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Anuncios/Publicados', {params: {data_inicio, data_fim, id_grupo, id_concessionaria}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}
export const fetchAnunciosVendidos = async (data_inicio: string, data_fim: string, id_grupo: string | null, id_concessionaria: string | null) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Anuncios/Vendidos', {params: {data_inicio, data_fim, id_grupo, id_concessionaria}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}
export const fetchAnunciosNaoVendidos = async (data_inicio: string, data_fim: string, id_grupo: string | null, id_concessionaria: string | null) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Anuncios/NaoVendidos', {params: {data_inicio, data_fim, id_grupo, id_concessionaria}});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}

export const exportAnunciosExcel = async (
  data_inicio: string,
  data_fim: string,
  tipo: string,
  id_grupo?: string | null,
  id_concessionaria?: string | null,
) => {
  try {
    const response = await BaseClient.get('Admin/Relatorio/Get/Anuncios/Excel', {
      responseType: 'blob',
      params: {
        data_inicio,
        data_fim,
        tipo,
        id_grupo: id_grupo || undefined,
        id_concessionaria: id_concessionaria || undefined,
      },
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `anuncios_${tipo}_${data_inicio}_${data_fim}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar Excel. Contate o administrador." };
  }
}

export const exportShopkeeperAnaliticooCsv= async (
  dat_inicial: string | null,
  dat_final: string | null,
 ) => {
  try {
    const response = await BaseClient.get("Admin/Relatorio/Get/Lojistas/Csv", 
      {
      responseType: 'blob',
      params: {
      dat_inicial: dat_inicial,
      dat_final: dat_final
    }});

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `lojistas_analitico_${dat_inicial}_${dat_final}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar CSV. Contate o administrador." };
  }
 }